import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { BaseTransformer } from './BaseTransformer';
import moment from "moment";
export var ActEventTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ActEventTransformer, _BaseTransformer);
  var _super = _createSuper(ActEventTransformer);
  function ActEventTransformer() {
    _classCallCheck(this, ActEventTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ActEventTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      var start = data.start_date;
      var end = data.end_date;
      var startTime = '';
      var endTime = '';
      var date = '';
      var dateRange = [];
      if (data.calendar && data.calendar.value && (data.calendar.value == 1 || data.calendar.value == 2 || data.calendar.value == 4 || data.calendar.value == 7)) {
        startTime = start ? moment(start).format("HH:mm") : '';
        endTime = end ? moment(end).format("HH:mm") : '';
        date = end ? moment(end).format("YYYY-MM-DD") : '';
        var startDate = start ? moment(start).format("YYYY-MM-DD") : '';
        dateRange = [startDate, date];
      }
      return {
        recordId: data.record_id,
        record_id: data.record_id,
        subject: data.subject,
        date: date,
        dateRange: dateRange,
        startDate: data.start_date,
        endDate: data.end_date,
        startTime: startTime,
        endTime: endTime,
        plannedStartDate: data.planned_start_date,
        plannedEndDate: data.planned_end_date,
        allday: data.allday,
        plannedAllday: data.planned_allday,
        eventStatus: {
          value: data.event_status ? data.event_status.value : null,
          label: data.event_status ? data.event_status.label : null
        },
        activityNotes: data.activity_notes,
        description: data.description,
        location: data.location,
        locationCoords: data.location_coords,
        scheduleNextActivity: data.schedule_next_activity,
        pages: data.pages,
        nextActivityDate: data.next_activity_date,
        activityStatus: {
          value: data.activity_status ? data.activity_status.value : null,
          label: data.activity_status ? data.activity_status.label : null
        },
        calendar: {
          value: data.calendar ? data.calendar.value : null,
          label: data.calendar ? data.calendar.label : null
        },
        project: {
          value: data.project ? data.project.value : null,
          label: data.project ? data.project.label : null
        },
        projectStatus: {
          value: data.project_status ? data.project_status.value : null,
          label: data.project_status ? data.project_status.label : null
        },
        accountName: {
          value: data.account_name ? data.account_name.value : null,
          label: data.account_name ? data.account_name.label : null
        },
        contactName: {
          value: data.contact_name ? data.contact_name.value : null,
          label: data.contact_name ? data.contact_name.label : null
        },
        deal: {
          value: data.deal ? data.deal.value : null,
          label: data.deal ? data.deal.label : null
        },
        lead: {
          value: data.lead ? data.lead.value : null,
          label: data.lead ? data.lead.label : null
        },
        section: {
          value: data.section ? data.section.value : null,
          label: data.section ? data.section.label : null
        },
        recordOwner: {
          value: data.record_owner ? data.record_owner.value : null,
          label: data.record_owner ? data.record_owner.label : null
        },
        relatedData: data.relatedData,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        showMore: false
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      var start = data.startDate ? data.startDate : moment().format("YYYY-MM-DD HH:mm:ss");
      var end = data.endDate ? data.endDate : moment().format("YYYY-MM-DD HH:mm:ss");
      // console.log("send",data)
      if (data && data.date && data.calendar && (data.calendar.value && data.calendar.value == 1 || data.calendar == 1)) {
        var date = moment(data.date).format("YYYY-MM-DD");
        start = moment(date + " " + data.startTime).format("YYYY-MM-DD HH:mm:ss");
        end = moment(date + " " + data.endTime).format("YYYY-MM-DD HH:mm:ss");
      } else if (data && data.date && data.calendar && (data.calendar.value && data.calendar.value == 2 || data.calendar == 2)) {
        var _date = moment(data.date).format("YYYY-MM-DD");
        start = moment(_date + " " + data.startTime).format("YYYY-MM-DD HH:mm:ss");
        end = moment(_date + " " + data.endTime).format("YYYY-MM-DD HH:mm:ss");
      } else if (data && data.date && data.calendar && (data.calendar.value && data.calendar.value == 4 || data.calendar == 4)) {
        var _date2 = moment(data.date).format("YYYY-MM-DD");
        start = moment(_date2 + " " + data.startTime).format("YYYY-MM-DD HH:mm:ss");
        end = moment(_date2 + " " + data.endTime).format("YYYY-MM-DD HH:mm:ss");
      } else if (data && data.dateRange && data.calendar && (data.calendar.value && data.calendar.value == 7 || data.calendar == 7)) {
        var _date3 = data.dateRange;
        var s = moment(_date3[0]).format("YYYY-MM-DD");
        var e = moment(_date3[1]).format("YYYY-MM-DD");
        start = moment(s + " " + data.startTime).format("YYYY-MM-DD HH:mm:ss");
        end = moment(e + " " + data.endTime).format("YYYY-MM-DD HH:mm:ss");
      }

      // console.log("send 1:",data)

      // let subject = data.subject;
      // let len = subject.length;
      // if(len>255){
      //   subject =  subject.substring(0,250) + "...";
      // }
      // data.activityNotes = data.subject;  
      // data.subject = subject; 
      console.log(data);
      return {
        record_id: data.recordId,
        calendar: data.calendar && data.calendar.value ? data.calendar.value : data.calendar ? data.calendar : '',
        subject: data.subject,
        activity_status: data.activityStatus ? data.activityStatus.value : null,
        location: data.location ? data.location : '',
        location_coords: data.locationCoords ? data.locationCoords : '',
        start_date: start,
        lead: data.lead && data.lead.value ? data.lead.value : data.lead ? data.lead : '',
        deal: data.deal && data.deal.value ? data.deal.value : data.deal ? data.deal : '',
        section: data.section ? data.section.value ? data.section.value : data.section : '',
        end_date: end,
        planned_start_date: start,
        planned_end_date: end,
        event_status: data.eventStatus && data.eventStatus.value ? data.eventStatus.value : '',
        activity_notes: data.activityNotes ? data.activityNotes : '',
        description: data.description ? data.description : '',
        record_owner: data.recordOwner ? data.recordOwner.value : null,
        project_status: data.projectStatus ? data.projectStatus.value ? data.projectStatus.value : data.projectStatus : null,
        project: data.project ? data.project.value : null,
        account_name: data.accountName ? data.accountName.value : null
      };
    }
  }]);
  return ActEventTransformer;
}(BaseTransformer);